import { ReactElement } from "react";
import { NativeSelect } from "@altimateai/lego";
import { Privacy } from "@/helpers/constants";

export type VisibilityFilter = typeof Privacy.PRIVATE | typeof Privacy.PUBLIC | "all";

export interface DataMatesVisibilityFilterProps {
  visibility: VisibilityFilter;
  onVisibilityChange: (value: VisibilityFilter) => void;
}

const visibilityOptions = [
  { label: "All", value: "all" },
  { label: "Public", value: Privacy.PUBLIC },
  { label: "Private", value: Privacy.PRIVATE },
];

export function DataMatesVisibilityFilter({
  visibility,
  onVisibilityChange,
}: DataMatesVisibilityFilterProps): ReactElement {
  return (
    <NativeSelect
      variant="outline"
      value={visibility}
      onChange={value => onVisibilityChange(value as VisibilityFilter)}
      options={visibilityOptions}
      buttonProps={{ className: "al-bg-white", "aria-label": "Filter by visibility" }}
    />
  );
}
